import React from "react";
import withFdsIconWrapper from './withFdsIconWrapper';

const ActionsArrowDownIcon = () => <svg viewBox="0 0 24 24"><g fillRule="evenodd"><g><polygon points="18.6600501 7.09699258 20.8785213 9.31546382 13.2995504 16.8944348 13.3157158 16.9106002 12.0161654 18.2101506 12 18.1939852 11.9838346 18.2101506 10.6842842 16.9106002 10.7004496 16.8944348 2.97598979 9.16997495 5.19446103 6.95150371 12 13.7570427 18.6600501 7.09699258" /></g></g></svg>;

export default withFdsIconWrapper(ActionsArrowDownIcon);